import UserAPI from '../api/UserAPI';
import { print } from '../managers/Logger'

class MainUser { 

	constructor() { 
		if (! MainUser.instance) { 
			this.state = { 
				token: null,
				user: null, 
				blockList: []
			}
			MainUser.instance = this;
		}

		return MainUser.instance
	}

	getToken(){
		return this.state.token
	}

	loadUserFromApi(callback, errorcallback) { 
		const userAPI = new UserAPI()
		weak = this
		userAPI.getMe(function(data){
			if (data != null) {
				weak.state.user = data
				print("USER LOADED FROM API: STATE IS")
				print(weak.state.user)
			}
			callback(data)
			return
		}, 
		errorcallback
		)
	}

	loadUserFromData(data){ 
		this.state.user = data
	}

	getUserId(){
		return this.state.user.id
	}

	getMyEventChats(callback, errorcallback) { 
		const userAPI = new UserAPI()
		userAPI.getUserEventsChats(callback, errorcallback)
	}

	getUser() { 
		return this.state.user
	}

	updateMe(email, username, callback, errorcallback) { 
		const userAPI = new UserAPI()
		var data = {}
		if (email != null) { 
			data.email = email
		}

		if (username != null) { 
			data.username = username
		}
		userAPI.updateUser(data, callback, errorcallback)
	}

	blockUser(userId) { 
		this.state.blockList.push(userId)
	}

	getBlockList(){
		return this.state.blockList
	}

	getAdminAccess(user) { 
		if (user == null) { 
			return null
		}
		
		if (user.promoter_set !== undefined && user.promoter_set !== null) { 
			if (user.promoter_set.length > 0) { 
				return user.promoter_set[0]
			}
		}
		print(user.access_set)
		if (user.access_set !== undefined && user.access_set !== null) { 
			const AdminAccess = user.access_set.find(function(other) { 
				other.access_level === 'admin'
			})

			return adminAccess 
		}

		return null
	}

	hasAdminAccess(user) { 
		const access = this.getAdminAccess(user)
		if (access === null) { 
			return false
		} else { 
			return true
		}
	}

}

const instance = new MainUser()

export default instance